import getTimeFromZeroTimezoneDate from './getTimeFromZeroTimezoneDate';
import formatTimeTo12Hour from './formatTimeTo12Hour';

export default function getFormattedTime(timeFormat, value) {
  return timeFormat === 'HH:mm'
    ? getTimeFromZeroTimezoneDate(value)
    : formatTimeTo12Hour(getTimeFromZeroTimezoneDate(value));
}
